export type AdviceDataSourceType = 'SATELLITE' | 'SENSOR' | 'FUSION';

export const IrrigationAdviceDataSource = {
  FUSION: 'FUSION' as AdviceDataSourceType,
  SATELLITE: 'SATELLITE' as AdviceDataSourceType,
  SENSOR: 'SENSOR' as AdviceDataSourceType,
};
